import React from 'react';

const UserRights: React.FC = () => {
  return <div>User Rights Component</div>;
};

export default UserRights;